import { getRoot, IStateTreeNode } from 'mobx-state-tree';
import { IRootStore } from '@stores/RootStore';
import { IProfileStore } from './types';

export const withProfileStore = (self: IStateTreeNode) => {
  return {
    views: {
      get profileStore(): IProfileStore {
        return getRoot<IRootStore>(self).profileStore;
      },
    },
  };
};
